<template>
  <div>
    <div v-if="!upload">
      <figure>
        <img v-if="img" :src="getImage(img)" id="post-image-preview" />
        <img
          v-else
          src="@/assets/logos/image-unavailable.png"
          id="post-image-preview"
        />
      </figure>
      <button class="button is-info is-small" @click="upload = !upload">
        Add Thumbnail
      </button>
    </div>
    <UploadImage
      v-else
      :upload="upload"
      @toggle="toggle"
      @updateSettingsLogo="emitLogo"
    />
  </div>
</template>

<script>
import UploadImage from "@/components/UploadImage.vue";

export default {
  name: "PostThumbnail",
  props: {
    img: {
      type: String,
      default: () => ""
    },
    itemType: {
      type: String,
      default: () => "logo"
    }
  },
  components: {
    UploadImage: UploadImage
  },
  data() {
    return {
      upload: false,
      imageData: null
    };
  },
  methods: {
    toggle(value) {
      this.upload = value;
    },
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    },
    emitLogo(value) {
      this.image = value;
      this.$emit("updatePostPhoto", value);
    }
  },
  computed: {
    image: {
      get() {
        return this.img;
      },
      set(value) {
        this.imgData = value;
      }
    }
  },
  watch: {
    upload() {
      this.$emit('isUpdating', this.upload)
    }
  }
};
</script>

<style lang="scss">
#post-image-preview {
}
</style>
